<template>
  <div>
      <img class="logo-menu" id="logo" alt="logo" src="../assets/logos/mdcai_logo_dark_v1.svg">
      
      <b-link class="link-menu" @click="$router.push('dashboard')">Dashboard</b-link><br />
      <b-link class="link-menu" @click="$router.push('activity_log')">Activity Log</b-link><br />
      <b-link class="link-menu" @click="$router.push('test_platform')">Test Platform</b-link><br />
      <b-link class="link-menu" @click="$router.push('qa_matrix')">Q&A Matrix</b-link><br />
      <b-link class="link-menu" @click="$router.push('jokes')">Jokes</b-link><br />

      <br />
      <b-link class="link-menu" @click="$router.push('user_whitelist')">User Whitelist</b-link><br />


  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
